import {useMemo} from 'react'
import {getSharedLibraryAssetUrl} from '../utils/url'
import useOcapiSite from './useOcapiSite'

/**
 * Custom hook to resolve an asset URL (videos, PDFs, etc. - not images) relative to the sharedLibrary base URL.
 * Uses the sharedLibraryStatic URL from OCAPI to resolve relative asset URLs.
 * Memoizes the result to avoid unnecessary recalculations.
 *
 * Note: This is for non-image assets in the shared library. For images, use useDisBaseLink which
 * leverages Salesforce Dynamic Image Service.
 *
 * @param {string} assetSrc - The asset source URL (can be relative or absolute)
 * @returns {string|null} The resolved asset URL or null if the URL is invalid or sharedLibraryStatic is not loaded
 *
 * @example
 * function MyComponent() {
 *   const assetSrc = 'cms_assets/videos/product-demo.mp4'
 *   const assetUrl = useSharedLibraryAssetUrl(assetSrc)
 *   // assetUrl: 'https://dev.stokke.com/on/demandware.static/-/Library-Sites-StokkeSharedLibrary/de_DE/v1761758784946/cms_assets/videos/product-demo.mp4'
 * }
 */
export default function useSharedLibraryAssetUrl(assetSrc) {
    const {sharedLibraryStatic} = useOcapiSite()

    return useMemo(
        () => getSharedLibraryAssetUrl(assetSrc, sharedLibraryStatic),
        [assetSrc, sharedLibraryStatic]
    )
}
